export const BACKEND_URL = process.env["REACT_APP_BACKEND_URL"];

if (!BACKEND_URL) {
  console.log(
    "No backend url string. Set REACT_APP_BACKEND_URL environment variable."
  );
  process.exit(1);
}

export const ACTIVE_DOMAIN = process.env["REACT_APP_ACTIVE_DOMAIN"];

// console.log(ACTIVE_DOMAIN)
export const BUYER_CLIENT_URL = process.env["REACT_APP_BUYER_CLIENT_URL"];

if (!BUYER_CLIENT_URL) {
  console.log(
    "No backend url string. Set REACT_APP_BUYER_CLIENT_URL environment variable."
  );
  process.exit(1);
}
export const SELLER_CLIENT_URL = process.env["REACT_APP_SELLER_CLIENT_URL"];

if (!SELLER_CLIENT_URL) {
  console.log(
    "No backend url string. Set REACT_APP_BUYER_CLIENT_URL environment variable."
  );
  process.exit(1);
}
export const INFO_ACTIVE = process.env["REACT_APP_INFO_ACTIVE"];

if (!INFO_ACTIVE) {
  console.log(
    "No Info active button. Set REACT_APP_INFO_ACTIVE environment variable."
  );
  process.exit(1);
}

export const BASE_PATH = process.env["PUBLIC_URL"];
if (!BASE_PATH) {
  console.log(
    "No backend url string. Set REACT_APP_MOCK_SERVER_URL environment variable."
  );
  // process.exit(1);
}